import { Row, Col } from "../../App.styles";

const Photo = () => {
  return (
    <>
      <Row>
        <Col>
          <p>Complete by: Photo</p>
        </Col>
      </Row>
    </>
  );
};

export default Photo;
